import { relations } from 'drizzle-orm'
import { doublePrecision, index, jsonb, pgTable, text, timestamp } from 'drizzle-orm/pg-core'
import type { Measurement } from '../../../measurements'
import { entities } from '../entities/entities.schema'
import type { Unit } from '../units'
import { id, createdAt, updatedAt } from '../utils/columns'
import { receivables } from './receivables.schema'

export const jobCustomItems = pgTable(
  'job_custom_items',
  {
    id,
    entityId: text('entity_id')
      .notNull()
      .references(() => entities.id),
    jobId: text('job_id').notNull(),
    jobTypeId: text('job_type_id').notNull(),
    externalId: text('external_id'),
    name: text('name').notNull(),
    description: text('description'),
    quantity: doublePrecision('quantity').notNull(),
    unit: text('unit').$type<Unit>().notNull(),
    /** Aufmaß: internal rows whose sum is `quantity`; carried onto the invoice line. See `measurements.ts`. */
    measurements: jsonb('measurements').$type<Measurement[]>(),
    usedReceivableId: text('used_receivable_id'),
    usedAt: timestamp('used_at', { mode: 'date' }),
    createdAt,
    updatedAt,
  },
  (table) => [
    index('idx_job_custom_items_entity_job').on(table.entityId, table.jobTypeId, table.jobId),
    index('idx_job_custom_items_external_id').on(table.entityId, table.externalId),
  ],
)

export type JobCustomItem = typeof jobCustomItems.$inferSelect
export type JobCustomItemInsert = typeof jobCustomItems.$inferInsert

export const jobCustomItemsRelations = relations(jobCustomItems, ({ one }) => ({
  entity: one(entities, {
    fields: [jobCustomItems.entityId],
    references: [entities.id],
  }),
  usedReceivable: one(receivables, {
    fields: [jobCustomItems.usedReceivableId],
    references: [receivables.id],
  }),
}))
